import { render } from "./IpOSMaterialConsumidoReportPage.vue?vue&type=template&id=0a1e61b8"
import script from "./IpOSMaterialConsumidoReportPage.vue?vue&type=script&lang=js"
export * from "./IpOSMaterialConsumidoReportPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__